import i18n from 'i18next';

import { addModal } from '@/exceed';

import getModalLearningObjectiveSchema from '../schemas/getModalLearningObjectiveSchema';

export default async ({ action, data, item, mutateLearningObjective }) => {
  const { type, payload } = await addModal({
    actions: [
      {
        action: 'save',
        element: 'button',
        color: 'brand',
        size: 'medium',
        text: i18n.t('learning-objectives.modal.save'),
        getIsDisabled: ({ hasFormError }) => hasFormError,
      },
      {
        action: 'cancel',
        variant: 'ghost',
        size: 'small',
        element: 'button',
        text: i18n.t('cancel'),
      },
    ],
    isFullScreen: true,
    title:
      action === 'add'
        ? i18n.t('learning-objectives.modal.add-title')
        : i18n.t('learning-objectives.modal.edit-title'),
    hasCloseButton: true,
    schema: getModalLearningObjectiveSchema(),
    model: action === 'edit' && { ...item.data },
  });

  if (type !== 'save') return;

  mutateLearningObjective(action, { ...data, ...payload });
};
